import React from "react";

const NavBaseButton = ({ children, ...rest }) => {
  return (
    <button {...rest} className={"btn btn-nav"} type="button" tabIndex="0">
      {children}
    </button>
  );
};

export default NavBaseButton;
